export default {
  methods: {
    open() {
      this.$refs['sidebar'].open()
    },
    close() {
      this.$refs['sidebar'].close()
    }
  }
}
